import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Button, Modal, Row } from 'react-bootstrap'
import { FiEdit3 as EditIcon } from 'react-icons/fi'
import {
  catalogContainer,
  customerContainer,
  promotionContainer,
  subscriptionContainer,
} from 'src/models'
import { i18nTranslate } from 'src/utils'
import { LinkWithLocale, ImageComponent } from 'src/views/components'
import PriceSubscription from 'src/views/components/Price/PriceSubscription'
import { SubscriptionMultiVariants } from './SubscriptionMultiVariants/SubscriptionMultiVariants'
import './styles.scss'
import {
  getNotPurchasableSkuStatus,
  getNotPurchasableStatusTestId,
} from 'src/utils/commonUtils'

@observer
class EditBundleMultiVariants extends React.Component {
  @observable isToShowBundleEditModal = false
  @observable productData = {}
  @observable finalBundleData = {}
  @observable catagoryId = ''
  @observable updatedVariantSkus = []

  constructor(props) {
    super(props)
  }

  cloneSubscriptionData = () => {
    const { isBundle = false, bundleItems = {} } = this.props.bundleData || {}
    const { mandatoryCount = [], optionalCount = [] } = bundleItems

    let mandateSkus = []
    let optionalSkus = []

    try {
      mandateSkus = JSON.parse(JSON.stringify(mandatoryCount))
      optionalSkus = JSON.parse(JSON.stringify(optionalCount))
    } catch (e) {
      console.log('Unable to clone subscription response', e)
    }

    this.finalBundleData = {
      ...bundleItems,
      mandatoryCount: mandateSkus,
      optionalCount: optionalSkus,
    }
  }

  renderMultiVariantEditWithSelections = (
    bundleItems = [],
    variantInfo = {},
    disableSelections = false
  ) => {
    const { bundle = {}, mandatoryCount = [], optionalCount = [] } = bundleItems
    const productId = bundle?.[0]?.productId || bundle?.[0]?.id
    const variantsList = [...mandatoryCount, ...optionalCount]

    return (
      <div className="multi-variant-details">
        <div
          className={`bundle-multivariant-selections-${this.props.activeTab}`}>
          {variantInfo?.isNormalSkuWithMultiVariant && (
            <>
              <div className="normal-pdt-selections-text">
                {i18nTranslate('Subscription.variant.selection', 'Selections')}
              </div>
              <div className="normal-sku-variant">
                {variantInfo?.variantLabel}
              </div>
            </>
          )}
          {variantsList?.length > 0 && (
            <>
              <Button
                className="bundle-multivariant-edit-button"
                variant="black"
                data-testid="bundle-multivariant-edit-button"
                onClick={() => this.handleMultiVariantEdit(productId)}
                disabled={disableSelections}
                tabIndex={disableSelections ? -1 : 0}
                aria-disabled={disableSelections}>
                <EditIcon aria-label={'bundle multivariant edit button'} />{' '}
                {i18nTranslate('Subscription.variant.selection', 'Selections')}
              </Button>
              <div
                className="bundle-multivariant-selected-items"
                data-testid="bundle-multivariant-selected-items">
                {variantsList?.map((variant, index) => {
                  const variantName =
                    variant?.name || variant?.skuProperties?.variantLabel
                  return <div key={index}>{variantName}</div>
                })}
              </div>
            </>
          )}
        </div>
      </div>
    )
  }

  handleMultiVariantEdit = async productId => {
    //Make Product call for bundle multi variant edit
    const response = await catalogContainer.getProduct({
      productId: productId,
    })
    if (catalogContainer.isSuccessResponse(response)) {
      this.productData = response.product?.[0] || {}
      this.catagoryId = response?.category?.identifier || ''
      this.isToShowBundleEditModal =
        this.productData && this.productData?.type === 'bundle'

      this.cloneSubscriptionData()
    }
  }

  getBundleMandateSkusOnEdit = (
    productMandatorySkus = {},
    subsMandatorySkus = []
  ) => {
    const finalMandateArray = []

    productMandatorySkus?.forEach((mandateItem, index) => {
      let filterSkus = []
      mandateItem.sku?.length > 1
        ? mandateItem.sku?.forEach(element => {
            subsMandatorySkus.forEach(subsItem => {
              if (subsItem.id === element.identifier) {
                filterSkus.push({
                  isSelectedForEdit: true,
                  ...element,
                })
              }
            })
            const found = filterSkus.find(
              sku => sku.identifier === element.identifier
            )
            !found && filterSkus.push({ isSelectedForEdit: false, ...element })
          })
        : filterSkus.push(mandateItem.sku[0])

      finalMandateArray.push({
        ...mandateItem,
        productId: mandateItem.identifier,
        sku: filterSkus,
      })
    })

    return finalMandateArray
  }

  getOptionalSkusOnEdit = (productOptionalSkus = [], subsOptionalSkus = []) => {
    const finalOptionalArray = []
    productOptionalSkus.forEach(optionalItem => {
      let matchedSkus = []
      let isOptionalPdtAdded = false
      optionalItem?.sku?.forEach(element => {
        const match = subsOptionalSkus.find(
          subsItem => subsItem.id === element.identifier
        )
        if (match) {
          matchedSkus.push({
            ...element,
            isOptionalSkuSelected: true,
          })
          isOptionalPdtAdded = true
        } else {
          matchedSkus.push({
            ...element,
            isOptionalSkuSelected: false,
          })
        }
      })

      if (matchedSkus.length > 0) {
        finalOptionalArray.push({
          ...optionalItem,
          productId: optionalItem.identifier,
          sku: matchedSkus,
          quantity: optionalItem.properties?.quantity,
          optionalProductAdded: isOptionalPdtAdded,
        })
      }
    })

    return finalOptionalArray
  }

  renderBundleMultiVariants = (product = {}) => {
    const {
      bundleMandatoryProducts = [],
      bundleOptionalProducts = [],
      type,
      properties = {},
    } = product

    const {
      isBundle = false,
      bundleItems = {},
      quantity,
    } = this.props.bundleData || {} //Subscription data
    const { mandatoryCount = [], optionalCount = [] } = bundleItems

    const {
      bundleMandatoryProducts: finalBundleMandateSkuArray,
      bundleOptionalProducts: finalBundleOptionalSkuArray,
    } = this.getProcessedBundleSkus(
      bundleMandatoryProducts,
      bundleOptionalProducts,
      mandatoryCount,
      optionalCount
    )

    const productData = {
      bundleMandatoryProducts: finalBundleMandateSkuArray,
      bundleOptionalProducts: finalBundleOptionalSkuArray,
      productId: product.identifier || '',
      type,
      properties,
      productQuantity: quantity,
    }

    return (
      <div
        className="subs-multivariant-section"
        data-testid="qa-edit-bundle-multivariant-section">
        <SubscriptionMultiVariants
          productData={productData}
          actionType="edit"
          isBundle={isBundle}
          updateSelectedVariant={this.updateSelectedVariant}
        />
      </div>
    )
  }

  updateSelectedVariant = (variantData = {}) => {
    const bundleData = []
    const manadateSkusData =
      Array.isArray(variantData.bundleMandatoryProducts) &&
      variantData.bundleMandatoryProducts?.length > 0
        ? variantData.bundleMandatoryProducts
        : []

    const optionalSkusData =
      Array.isArray(variantData.bundleOptionalProducts) &&
      variantData.bundleOptionalProducts?.length > 0
        ? variantData.bundleOptionalProducts
        : []

    manadateSkusData.forEach(item => {
      const { sku = [] } = item
      const selectedSku =
        sku.find(skuItem => skuItem.isSelectedForEdit) || item.selectedSku

      bundleData.push({
        productId: item.identifier,
        skuId: selectedSku.identifier,
        type: 'MANDATORY',
        skuQuantity: item?.properties?.quantity,
        availableChannels: selectedSku?.properties?.availableChannels || '',
        slug: selectedSku?.properties?.slug || '',
      })
    })

    optionalSkusData.forEach(item => {
      const { sku = [] } = item
      if (item.optionalProductAdded) {
        const selectedSku =
          sku.find(skuItem => skuItem.isOptionalSkuSelected) || item.selectedSku

        bundleData.push({
          productId: item.identifier,
          skuId: selectedSku.identifier,
          type: 'OPTIONAL',
          skuQuantity: item?.properties?.quantity,
          availableChannels: selectedSku?.properties?.availableChannels || '',
          slug: selectedSku?.properties?.slug || '',
        })
      }
    })
    //Saving updated data here on every change in edit modal
    this.updatedVariantSkus = bundleData
  }

  renderBundleProductDetails = productData => {
    const {
      properties = {},
      bundleMandatoryProducts = [],
      bundleOptionalProducts = [],
      identifier = '',
      totalValue = {},
    } = productData
    const { name = '', primaryimage = '', slug = '' } = properties

    const {
      quantity,
      pathUrl = '',
      priceObj = {},
    } = this.props.bundleData || {}
    const currencySign =
      subscriptionContainer.subscriptionPreferenceResponse?.currencySign || '$'
    const unitValue =
      promotionContainer.subscriptionV2PromoResponse?.unitValue ||
      priceObj?.totalValue ||
      {}
    const originalPrice = unitValue?.originalPrice || ''
    const priceAfterDiscount = unitValue?.priceAfterDiscount || ''
    const displayTotalValue = totalValue?.priceAfterDiscount || ''

    const priceObj1 = {
      currencySymbol: currencySign,
      price: parseFloat(originalPrice),
      discountedPrice: parseFloat(priceAfterDiscount),
      totalValue: {
        originalPrice: parseFloat(originalPrice),
        priceAfterDiscount: parseFloat(priceAfterDiscount),
      },
      unitValue,
    }

    return (
      <div
        className="bundle-product-wrapper d-flex"
        data-testid="qa-edit-bundle-product-wrapper">
        <div className="bundle-product-img">
          {
            <LinkWithLocale
              to={{
                pathname: pathUrl || '',
              }}
              className={`prod-image-wrapper w-100`}>
              <ImageComponent
                width="100px"
                height="100px"
                optimizeImage={true}
                src={primaryimage}
                alt={name}
                className={`mw-100 mh-100 prod-img`}
                testId="qa-sub-bundle-product-image"
              />
            </LinkWithLocale>
          }
        </div>
        <div className="bundle-product-details">
          <LinkWithLocale
            to={{
              pathname: pathUrl || '',
            }}
            className={'product-card-product-link'}>
            <div
              className="subs-product-title"
              data-testid="qa-sub-product-name">
              {name}
            </div>
            <div
              className="subs-product-sku"
              data-testid="qa-sub-product-skuId">
              <span className="">{i18nTranslate('cart.itemId', 'SKU')}:</span>
              <span className="pl-1">{identifier}</span>
            </div>
          </LinkWithLocale>

          {quantity && (
            <div
              className="quantity-label pr-1 subs-product-quantity"
              data-testid="qa-sub-product-quantity-edit-modal">
              <span className="pr-1">
                {i18nTranslate('quantity', 'Quantity')}:
              </span>
              {quantity}
            </div>
          )}
          <div className="subscription-price d-flex w-100 subs-product-price">
            <PriceSubscription
              classStyles={`d-flex align-items-center flex-row justify-content-lg-end mb-2`}
              transactionPrice={priceObj1}
            />
          </div>
        </div>
      </div>
    )
  }

  getUpdateBundleSkus = () => {
    const {
      bundleMandatoryProducts = [],
      bundleOptionalProducts = [],
      identifier,
      type,
      properties,
    } = this.productData

    const {
      isBundle = false,
      priceObj = {},
      quantity,
    } = this.props.bundleData || {}

    const getSkuDetails = (element = {}) => {
      const {
        id = '',
        productId = '',
        type = '',
        skuQuantity,
        skuProperties,
      } = element
      return {
        productId,
        skuId: id,
        type,
        skuQuantity: skuQuantity,
        availableChannels: skuProperties?.availableChannels,
        slug: skuProperties?.slug,
      }
    }

    const getDefaultBundleSkus = () => {
      const mandateSkus =
        this.finalBundleData.mandatoryCount?.length > 0
          ? this.finalBundleData.mandatoryCount?.map?.(getSkuDetails)
          : []
      const optionalSkus =
        this.finalBundleData.optionalCount?.length > 0
          ? this.finalBundleData.optionalCount?.map?.(getSkuDetails)
          : []
      return mandateSkus.length > 0 && optionalSkus.length > 0
        ? [...mandateSkus, ...optionalSkus]
        : mandateSkus.length > 0
          ? [...mandateSkus]
          : optionalSkus.length > 0
            ? [...optionalSkus]
            : []
    }

    let skus = []

    skus =
      Array.isArray(this.updatedVariantSkus) &&
      this.updatedVariantSkus?.length > 0
        ? this.updatedVariantSkus
        : getDefaultBundleSkus()

    const headerProductDetails = {
      productId: identifier,
      skuId: identifier,
      type: type?.toUpperCase(),
      availableChannels: properties?.availableChannels,
    }
    skus = [headerProductDetails, ...skus]

    const updateBundlePostData = {
      quantity,
      skus: skus,
      isSubscription: true,
    }
    return updateBundlePostData
  }

  handleUpdateBundleVariants = async () => {
    const { subscriptionId = '' } = this.props.bundleData || {}
    const {
      itemId = '',
      successCallBack = function () {},
      isFromMultipleSubscriptions = false,
    } = this.props || {}
    const {
      frequencyData = '',
      month = 0,
      selectedSubscriptionDate = '',
      activeTab = '',
    } = this.props

    const updateBundlePostData = this.getUpdateBundleSkus()

    const payload = {
      subscriptionId: subscriptionId,
      patchProperties: {
        ...updateBundlePostData,
        subscription: { ...frequencyData },
        properties: {
          categoryId: this.catagoryId,
          category: this.catagoryId,
          slug: '',
          scanQualifiedCount: '',
        },
      },
      itemId: itemId,
    }

    if (!isFromMultipleSubscriptions) {
      payload.patchProperties = {
        ...payload.patchProperties,
        month: month,
        orderProcessedDate: selectedSubscriptionDate,
      }
    }

    const response = await subscriptionContainer.updateSubscriptionVariant(
      payload,
      false,
      isFromMultipleSubscriptions
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      if (isFromMultipleSubscriptions) {
        successCallBack?.(subscriptionId, month)
      } else if (activeTab === 'schedule') {
        subscriptionContainer.getAllSubscriptionsPreference(
          customerContainer.userId,
          '',
          true
        )
      } else {
        subscriptionContainer.getAllSubscriptionsPreference(
          customerContainer.userId,
          month,
          false,
          '',
          selectedSubscriptionDate
        )
      }
    }
    //Dismissing the edit modal after update patch API
    this.onHide()
  }

  renderButtonsForEditBundle = () => {
    const { bundleMandatoryProducts, bundleOptionalProducts } =
      this.getCurrentVariantData()
    const { flagInventory, inventoryStatusView, shouldDisableButton } =
      getNotPurchasableSkuStatus({
        bundleMandatoryProducts,
        bundleOptionalProducts,
      })
    const cancelText = i18nTranslate('Subscription.cancel', 'Cancel')
    const cancelLabel = cancelText?.toLowerCase()
    return (
      <>
        {flagInventory && (
          <>
            <Row
              noGutters
              className="w-100 v2-inventory-message"
              data-testid={getNotPurchasableStatusTestId(inventoryStatusView)}>
              <p
                className={
                  'availability-text font-weight-bold p-0 m-0 text-bundle-danger'
                }
                aria-live="polite"
                role="alert">
                {inventoryStatusView}
              </p>
            </Row>
            <div className="inventory-message-margin" />
          </>
        )}
        <div className="update-bundle-btn">
          <Button
            className="bundle-multivariant-update-button"
            variant="black"
            data-testid="bundle-multivariant-update-button"
            disabled={shouldDisableButton}
            onClick={() => this.handleUpdateBundleVariants()}>
            {i18nTranslate('Subscription.variantModal.update', 'Update Bundle')}
          </Button>
        </div>
        <div className="cancel-bundle-btn">
          <Button
            className="bundle-multivariant-cancel-button"
            variant="black"
            data-testid="bundle-multivariant-cancel-button"
            onClick={() => this.onHide()}>
            {cancelLabel}
          </Button>
        </div>
      </>
    )
  }

  getProcessedBundleSkus = (
    bundleMandatoryProducts = [],
    bundleOptionalProducts = [],
    mandatorySelected = [],
    optionalSelected = []
  ) => {
    return {
      bundleMandatoryProducts: this.getBundleMandateSkusOnEdit(
        bundleMandatoryProducts,
        mandatorySelected
      ),
      bundleOptionalProducts: this.getOptionalSkusOnEdit(
        bundleOptionalProducts,
        optionalSelected
      ),
    }
  }

  getCurrentVariantData = () => {
    try {
      const { bundleMandatoryProducts = [], bundleOptionalProducts = [] } =
        this.productData || {}
      const { mandatoryCount = [], optionalCount = [] } =
        this.finalBundleData || {}

      // Use updatedVariantSkus if user has made changes
      if (
        Array.isArray(this.updatedVariantSkus) &&
        this.updatedVariantSkus?.length > 0
      ) {
        const mandatorySelected = this.updatedVariantSkus
          .filter(item => item.type === 'MANDATORY')
          .map(item => ({ id: item.skuId }))
        const optionalSelected = this.updatedVariantSkus
          .filter(item => item.type === 'OPTIONAL')
          .map(item => ({ id: item.skuId }))

        return this.getProcessedBundleSkus(
          bundleMandatoryProducts,
          bundleOptionalProducts,
          mandatorySelected,
          optionalSelected
        )
      }

      // First render
      return this.getProcessedBundleSkus(
        bundleMandatoryProducts,
        bundleOptionalProducts,
        mandatoryCount,
        optionalCount
      )
    } catch (error) {
      console.error('Error in getCurrentVariantData:', error)
      return {
        bundleMandatoryProducts: [],
        bundleOptionalProducts: [],
      }
    }
  }

  showBundleEditModal = (productData = {}) => {
    return (
      <Modal
        show={true}
        tabIndex={0}
        onHide={() => this.onHide()}
        dialogClassName="edit-bundle-variant-modal-container"
        data-testid="qa-edit-bundle-modal"
        aria-label={i18nTranslate(
          'subscription.buildBundle',
          'Build Your Bundle'
        )}
        centered>
        <Modal.Header closeButton={true}>
          <Modal.Title
            className="variant-modal-title"
            data-testid="qa-edit-bundle-modal-title">
            {i18nTranslate('subscription.buildBundle', 'Build Your Bundle')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="variant-edit-modal d-flex">
            {this.renderBundleProductDetails(productData)}
          </div>
          <div>{this.renderBundleMultiVariants(productData)}</div>
          <div className="edit-bundle-variant-btns">
            {this.renderButtonsForEditBundle()}
          </div>
        </Modal.Body>
      </Modal>
    )
  }

  onHide = () => {
    this.isToShowBundleEditModal = false
    this.productData = {}
    this.catagoryId = ''
    this.finalBundleData = []
  }
  render() {
    const { bundleData = {}, disableSelections = false } = this.props
    const { bundleItems = [], variantInfo = {} } = bundleData

    const customClass = disableSelections ? 'disabled' : ''
    return (
      <div className={`bundle-multi-variant-container ${customClass}`}>
        {this.renderMultiVariantEditWithSelections(
          bundleItems,
          variantInfo,
          disableSelections
        )}
        {this.isToShowBundleEditModal &&
          this.showBundleEditModal(this.productData)}
      </div>
    )
  }
}

export { EditBundleMultiVariants }
export default EditBundleMultiVariants
